const Pagination = {
	info: { totalCount: true, page: true, limit: true }
}

export default Pagination;